import styled from 'styled-components';
import { createPatientData } from 'modules/report/utils/patient-report-utils';
import { Link, useLocation, useSearchParams } from 'react-router-dom';

import ShareModal from 'modules/components/common/modal/sahre-modal/share-modal';
import ShareIcon from 'assets/img/shareBtn.svg';
import { Accordion, Button } from 'modules/components/common';
import { useGetPatientInfo } from 'modules/report/hooks/usePatientInfo';
import { useReport } from 'modules/report/hooks/useReport';

export const ReportWebNavbar = () => {
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const patientId = searchParams.get('patientId') || state.patientId;
  const { data: patientInfo, isLoading } = useGetPatientInfo(patientId);
  const { data: patientReportData } = useReport(patientId);

  const summeryContent = (
    <StyledReportNavbar>
      <div className="summary-container">
        <p>
          {patientInfo?.firstName
            ? patientInfo?.firstName + ' ' + patientInfo?.lastName
            : '_'}
        </p>
        <p className="phone-number">
          شماره تماس :<span>{patientInfo?.phoneNumber ?? '_'}</span>
        </p>
        <ShareModal>
          <div className="share-nav">
            اشتراک گذاری{' '}
            <button>
              <img src={ShareIcon} alt="" />
            </button>
          </div>
        </ShareModal>
      </div>
    </StyledReportNavbar>
  );

  const detailsContent = (
    <StyledReportNavbar>
      <div className="details-container">
        {createPatientData({
          ...patientInfo,
          serialNumber: patientReportData?.[14]?.serialNumber
        })?.map((data) => {
          return (
            <div className="item-container" key={data.title}>
              <span className="item-title"> {data.title} :</span>
              <span className="item-title item-value">{data.value}</span>
            </div>
          );
        })}
        <div className="edit-btn-container">
          <Link to={{ pathname: `/app/edit` }} state={{ patientId }}>
            <Button className="edit-patient" text="ویرایش اطلاعات" />
          </Link>
        </div>
      </div>
    </StyledReportNavbar>
  );

  return (
    <StyledReportNavbar>
      <div className="accordion-wrapper">
        <Accordion
          name={'patient-report-nav'}
          summeryContent={summeryContent}
          detailsContent={detailsContent}
        />
      </div>
    </StyledReportNavbar>
  );
};

export const StyledReportNavbar = styled.div`
  display: none;
  width: 100%;
  .accordion-wrapper {
    width: 100%;
    position: relative;
    margin-bottom: 50px;
  }
  .summary-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #4e4e4e;
    font-family: 'dana-bold';
    width: 100%;
    padding: 12px 24px;
    background: transparent;
  }
  .edit-btn-container {
    border-top: 1px solid #ffffff;
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .edit-patient {
    color: #753cbe;
    box-shadow: 1px 1px 2px 0px #00000029;
    padding: 12px 40px;
    font-size: 14px;
    font-family: 'dana-bold';
    text-align: center;
    border: 1px solid #ffffff;
  }
  .share-nav {
    color: #707070;
    display: flex;
    align-items: center;
    gap: 8px;
    button {
      cursor: pointer;
      background: #f5f5f5;
      display: grid;
      place-items: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #ffffff;
      outline: none;
      box-shadow: -2px -2px 7px 0px #ffffff, 1px 1px 10px 0px #0000001a;
    }
  }
  .phone-number {
    span {
      letter-spacing: 1px;
      padding-right: 8px;
      color: #753cbe;
    }
  }
  .details-container {
    margin: 0 27px;
    width: 100%;
    display: grid;
    grid-template-columns: auto max-content auto;
  }
  .details-container > :nth-child(3n) {
    justify-content: left;
  }
  .details-container > :nth-child(3n - 1) {
    /* justify-content: center; */
  }

  .item-container {
    border-top: 1px solid #ffff;
    display: flex;
    padding: 32px 0;
    align-items: center;
  }
  .item-title {
    font-size: 16px;
    font-family: 'dana-bold';
    width: max-content;
    color: #4e4e4e;
  }
  .item-value {
    padding-right: 10px;
    color: #753cbe;
  }

  @media screen and (min-width: 1024px) {
    display: flex;
  }
`;
